import o from"../colors/index.js";var r={color:o.professionalNavy,hoverColor:o.professionalNavy,activeColor:o.professionalNavy};export{r as default};
